/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Overwrite_TitleInputs */

const en_explorer_table_overwrite_title = /** @type {(inputs: Explorer_Table_Overwrite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite Project`)
};

const fr_explorer_table_overwrite_title = /** @type {(inputs: Explorer_Table_Overwrite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecraser le projet`)
};

const de_explorer_table_overwrite_title = /** @type {(inputs: Explorer_Table_Overwrite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt überschreiben`)
};

const it_explorer_table_overwrite_title = /** @type {(inputs: Explorer_Table_Overwrite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovrascrivi progetto`)
};

const ru_explorer_table_overwrite_title = /** @type {(inputs: Explorer_Table_Overwrite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезаписать проект`)
};

const es_explorer_table_overwrite_title = /** @type {(inputs: Explorer_Table_Overwrite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobrescribir proyecto`)
};

const zh_cn2_explorer_table_overwrite_title = /** @type {(inputs: Explorer_Table_Overwrite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`覆盖项目`)
};

const ja_explorer_table_overwrite_title = /** @type {(inputs: Explorer_Table_Overwrite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを上書き`)
};

const hi_explorer_table_overwrite_title = /** @type {(inputs: Explorer_Table_Overwrite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट को ओवरराइट करें`)
};

const pt_pt2_explorer_table_overwrite_title = /** @type {(inputs: Explorer_Table_Overwrite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto de Sobrescrita`)
};

/**
* | output |
* | --- |
* | "Overwrite Project" |
*
* @param {Explorer_Table_Overwrite_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_overwrite_title = /** @type {((inputs?: Explorer_Table_Overwrite_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Overwrite_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_overwrite_title(inputs)
	if (locale === "de") return de_explorer_table_overwrite_title(inputs)
	if (locale === "it") return it_explorer_table_overwrite_title(inputs)
	if (locale === "ru") return ru_explorer_table_overwrite_title(inputs)
	if (locale === "es") return es_explorer_table_overwrite_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_overwrite_title(inputs)
	if (locale === "ja") return ja_explorer_table_overwrite_title(inputs)
	if (locale === "hi") return hi_explorer_table_overwrite_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_overwrite_title(inputs)
	return en_explorer_table_overwrite_title(inputs)
});